export default __webpack_public_path__ + "static/media/cards-alt.928a3bee.png";